import { Box, Typography } from '@mui/material';
import { Button } from 'design-system';
import { MdAccessTime, MdChevronRight } from 'react-icons/md';
import Chips from './Chips';
import {
  ChipItem,
  chipContainerStyle,
  dropdownChipSx,
  isSuggestionList,
  RecentChip,
  sectionHeadingSx,
} from './SearchBar.utils';

export const RecentChipsSection = ({
  recents,
  selectedValue,
  onSelect,
}: {
  recents: RecentChip[];
  selectedValue: string;
  onSelect: (value: string) => void;
}) => (
  <>
    <Typography sx={sectionHeadingSx}>
      <MdAccessTime size={12} />
      Recent
    </Typography>
    <Chips
      data={recents}
      labelKey="label"
      valueKey="value"
      onChange={onSelect}
      value={selectedValue}
      sx={chipContainerStyle}
      chipSx={dropdownChipSx}
      selectedColor="warning"
    />
  </>
);

export const BrowseAllSection = ({
  showHeading,
  data,
  sourceData,
  selectedValue,
  onSelect,
}: {
  showHeading: boolean;
  data: ChipItem[];
  sourceData: ChipItem[];
  selectedValue: string;
  onSelect: (value: string) => void;
}) => {
  const hasSuggestionShape = isSuggestionList(sourceData);
  return (
    <>
      {showHeading && <Typography sx={sectionHeadingSx}>Browse all</Typography>}
      <Chips
        data={data}
        labelKey={hasSuggestionShape ? 'label' : undefined}
        valueKey={hasSuggestionShape ? 'value' : undefined}
        onChange={onSelect}
        value={selectedValue}
        sx={chipContainerStyle}
        chipSx={dropdownChipSx}
        selectedColor="warning"
        showAll
      />
    </>
  );
};

export const BrowseAllExpandButton = ({ label, onClick }: { label: string; onClick: () => void }) => (
  <Box sx={(theme) => ({ padding: theme.spacing(0, 1, 1) })}>
    <Button
      fullWidth
      variant="text"
      size="small"
      endIcon={<MdChevronRight size={18} />}
      onClick={onClick}
      sx={(theme) => ({
        justifyContent: 'center',
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.tertiary.light,
        borderRadius: theme.spacing(1),
        paddingY: theme.spacing(1),
        fontWeight: theme.typography.fontWeightMedium,
        '&:hover': { backgroundColor: theme.palette.tertiary.main },
      })}
    >
      {label}
    </Button>
  </Box>
);

export const NoMatchesState = ({ query }: { query: string }) => (
  <Box
    role="searchbarchipsempty"
    sx={(theme) => ({
      padding: theme.spacing(2),
      textAlign: 'center',
    })}
  >
    <Typography variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
      No matches for &ldquo;{query}&rdquo;
    </Typography>
  </Box>
);
